import { render, staticRenderFns } from "./EmailNewsletterButton.vue?vue&type=template&id=6826157c&"
import script from "./EmailNewsletterButton.vue?vue&type=script&lang=js&"
export * from "./EmailNewsletterButton.vue?vue&type=script&lang=js&"
import style0 from "./EmailNewsletterButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports